





























import {
  Vue,
  Component
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import LoadingSpinner from "@/shared/components/ui/LoadingSpinner.vue";
import { useBillingStore } from "@/shared/store/billing";

@Component({
  components: {
    Button,
    LoadingSpinner
  }
})
export default class AdminBillingEmployeeFees extends Vue {
  billingStore = useBillingStore();

  mounted () {
    this.billingStore.resetRecon();
    if (!this.billingStore.getReconBillingPeriodsLoaded) {
      this.billingStore.loadReconBillingPeriods();
    }
  }

  async getParameters (event) {
    if (!isNaN(event.target.value)) {
      try {
        this.billingStore.setReconPeriod({
          billingPeriodId: event.target.value,
          reportName: event.target.selectedOptions[0].label
        });
      } catch (err) {
        window.console.log("Error loading billing period: " + err);
      }
    } else {
      this.billingStore.resetReconPeriod();
    }
  }

  hasMonthlyBillingPeriods () {
    return this.billingStore.getReconBillingPeriodsLoaded
        && this.billingStore.getReconBillingPeriods.length > 0;
  }

  downloadCsv (e) {
    this.billingStore.downloadReconReport({
      periodId: this.billingStore.getSelectedReconPeriodId,
      periodName: this.billingStore.getSelectedReconPeriodName
    });
  }
}
